import Vue from 'vue'
import Router from 'vue-router'
import {auth} from './mod/auth.route'
import {main} from './mod/main.route'
import {intro} from './mod/intro.route'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/m/',
  routes: [
    ...auth,
    ...main,
    ...intro,
    {path: '*', redirect: '/login'}
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js